import React from 'react'
import './styles.css' ;
const NavBar = () => {
  return (
    <nav class="navbar navbar-expand-lg navbar-light container-fluid">
    <a class="navbar-brand" href="/">MessBill</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 justify-content-between">
            <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/">Home</a>
            </li>
            <li class="nav-item ml-auto">
                <a class="nav-link" href="/">Link</a>
            </li>
        </ul>
    </div>
</nav>
  )
}

export default NavBar